import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import { wizStandardInstance } from '@/services/instance'

export default class StdChangeRecordService {
  static async list(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdChangeRecord?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
}
